import './style.less';

export default function(event_id, profile_uid) {
  return ($scope, $uibModalInstance) => {
    'ngInject';
    $scope.event_id = event_id;
    $scope.profile_uid = profile_uid;
    $scope.close = () => $uibModalInstance.dismiss('cancel');
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/eventEvaluation/controller.js